import { useState } from 'react';
import { Dialog, Button } from '@/design-system';
import type { TemplateSummary } from '@/contracts/templates';

export interface DeleteTemplateConfirmDialogProps {
  template: TemplateSummary | null;
  onClose: () => void;
  onConfirm: () => Promise<void>;
}

/** SPEC-010 §86/AC-067/AC-068 — copy explicitly explains instantiated funnels are unaffected. */
export function DeleteTemplateConfirmDialog({ template, onClose, onConfirm }: DeleteTemplateConfirmDialogProps) {
  const [submitting, setSubmitting] = useState(false);

  if (!template) return null;

  async function handleConfirm() {
    setSubmitting(true);
    try {
      await onConfirm();
      onClose();
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <Dialog open={Boolean(template)} onClose={onClose} title="Excluir modelo">
      <p className="mb-4 text-sm text-text-secondary">
        <strong className="text-text-primary">{template.name}</strong> será excluído permanentemente. Os funis
        já criados a partir deste modelo não serão alterados.
      </p>
      <div className="flex justify-end gap-2">
        <Button type="button" variant="secondary" onClick={onClose} disabled={submitting}>
          Cancelar
        </Button>
        <Button type="button" variant="danger" onClick={handleConfirm} disabled={submitting}>
          {submitting ? 'Excluindo…' : 'Excluir'}
        </Button>
      </div>
    </Dialog>
  );
}
